module.exports = __webpack_public_path__ + "webwave-4.png?822f999e75591aea685b5bfa43c349bb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/webwave-4.png
// module id = 3QuL
// module chunks = 46